// Events
import { THEME_WISHLIST_UPDATED } from 'events';
// Lib
import Wishlist from 'lib/wishlist';
import { component } from 'picoapp';

import { heart, heartFilled } from 'utils/icons';
// Utils
import { clear, stringToNode } from 'utils/node';

export default component(async (node, ctx) => {
  const { handle } = node.dataset;

  const setIcon = (initial = false) => {
    clear(node);

    if (Wishlist.getItemIndex(handle) > -1) {
      node.innerHTML = heartFilled;

      if (!initial) {
        const pulse = stringToNode(heartFilled);
        pulse.classList.add(
          'animate-ping-once',
          'absolute',
          'top-1/2',
          'left-1/2',
          'transform',
          '-translate-x-1/2',
          '-translate-y-1/2',
          'origin-bottom-right',
        );
        node.appendChild(pulse);
      }
    } else {
      node.innerHTML = heart;
    }
  };

  setIcon(true);

  node.addEventListener('click', (event) => {
    event.stopPropagation();
    event.preventDefault();

    Wishlist.toggle(handle);
    setIcon();

    ctx.emit(THEME_WISHLIST_UPDATED, { wishlist: Wishlist.items });
  });
});
